import { Component, NgZone } from '@angular/core';
import { environment } from '@environments/environment';
import { ConsentService, startMonitoring } from '@ui-components/consent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'access';

  constructor(consent: ConsentService, ngZone: NgZone) {
    consent.choice$.subscribe(choice => {
      if (choice === 'granted') {
        startMonitoring(environment.new_relic.access.applicationId, ngZone);
      }
    });
  }
}
